export default __webpack_public_path__ + "static/media/new_logo_responsiveness.2b83d52f.png";